import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

export const TRN_BIOSEC_FETCH = 'TRN_BIOSEC_FETCH'
export const TRN_BIOSEC_FETCH_CANCELED = 'TRN_BIOSEC_FETCH_CANCELED'
export const TRN_BIOSEC_FETCH_ERROR = 'TRN_BIOSEC_FETCH_ERROR'
export const TRN_BIOSEC_FETCH_FULFILLED = 'TRN_BIOSEC_FETCH_FULFILLED'

export const biosecurityFetch = (tournamentId) => ({
  payload: { tournamentId },
  type: TRN_BIOSEC_FETCH,
})

export const biosecurityFetchFulfilled = (payload) => ({
  payload,
  type: TRN_BIOSEC_FETCH_FULFILLED,
})

export const biosecurityFetchCanceled = () => ({
  payload: null,
  type: TRN_BIOSEC_FETCH_CANCELED,
})

export const biosecurityFetchError = (payload) => ({
  payload,
  type: TRN_BIOSEC_FETCH_ERROR,
})

export const biosecurityFetchEpic = (action$) =>
  action$.pipe(
    ofType(TRN_BIOSEC_FETCH),
    mergeMap((action) =>
      epicServerRequest(
        'get',
        `${APP.api_url}/sports/tournament/${action.payload.tournamentId}/biosecurity/stats`,
        action,
      ).pipe(
        map(epicResponseHandler(biosecurityFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(TRN_BIOSEC_FETCH, TRN_BIOSEC_FETCH_CANCELED))),
        catchError(epicErrorHandler(biosecurityFetchError, action)),
      ),
    ),
  )
